/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/
import { Container} from 'react-bootstrap';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { UIState, ConfigState, LibraryData } from '../store/interfaces';
 
import styles from '../styles/postscreen.module.scss'
import LanguageSwitcherContainer from '../containers/LanguageSwitcherContainer';
import { LogoText } from './LogoText';
import LinkFooterContainer from '../containers/LinkFooterContainer';

 interface PostscreenProps {
    ui: UIState;
    config: ConfigState;
    library: LibraryData;
    onUiGoTo: (route: string) => void;
    onConfigSend: (lang: string) => void;
}

export function Postscreen(props: PostscreenProps) {
    const {t} = useTranslation();

    return (
        <Container fluid className={styles.container}>
            <div className={styles.content}>
                <div className={styles.header}>
                    <LogoText size={'small'} black={true}/>
                </div>
                <div className={styles.products}>
                    <div className={styles.productsLeft}>
                        <div>
                            <h1>{t('postscreen.title')}</h1>
                            <p dangerouslySetInnerHTML={{__html: t('postscreen.summary')}}></p>
                            {!isMobile && <a className={`${styles.buttonPrimary}`} href="https://www.strauss.com">{t('postscreen.toShop')}</a>}
                            {/*<button className={`${styles.buttonPrimary}`} disabled={props.ui.isSendingConfig} onClick={() => {props.onConfigSend(i18n.language)}}>DEBUG SEND AGAIN</button>*/}
                        </div>
                    </div>      
                    <div className={styles.productsRight}>
                        <h1>{t('postscreen.nextSteps')}</h1>
                        <div className={styles.furtherStepsContainer}>
                            <div>
                                <div>1</div>
                                <h1>{t('finalscreen.furtherActions.step1Header')}</h1>
                                <p>{t('finalscreen.furtherActions.step1Text')}</p>
                            </div>
                            <div>
                                <div>2</div>
                                <h1>{t('finalscreen.furtherActions.step2Header')}</h1>
                                <p>{t('finalscreen.furtherActions.step2Text')}</p>
                            </div>
                            <div>
                                <div>3</div>
                                <h1>{t('finalscreen.furtherActions.step3Header')}</h1>
                                <p>{t('finalscreen.furtherActions.step3Text')}</p>
                            </div>
                        </div>
                    </div>  
                    {isMobile && <a className={`${styles.buttonPrimary}`} href="https://www.strauss.com">{t('postscreen.toShop')}</a>}
                </div>            
                <div className={styles.footer}><LanguageSwitcherContainer black/><span className={styles.footerSeparator}></span><LinkFooterContainer fullWidth={true}/></div>
            </div>
        </Container>
    );
};